import { GlobalFeatureFlag } from 'constants/FeatureFlags';
import { getGlobalFeatureFlags } from './getGlobalFeatureFlags';

export function isOn(flag: GlobalFeatureFlag): boolean {
  return getGlobalFeatureFlags()[flag] === 'true';
}
